import { render, staticRenderFns } from "./BoxChart.vue?vue&type=template&id=3dd01d6d&scoped=true&lang=pug"
import script from "./BoxChart.vue?vue&type=script&lang=js"
export * from "./BoxChart.vue?vue&type=script&lang=js"
import style0 from "./BoxChart.vue?vue&type=style&index=0&id=3dd01d6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd01d6d",
  null
  
)

export default component.exports